import { useState, useEffect } from 'react'
import { supabase } from '../../lib/supabase'

export default function Comentarios() {
  const [comentarios, setComentarios] = useState([])
  const [loading, setLoading] = useState(true)
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedMarca, setSelectedMarca] = useState('')
  const [selectedEstado, setSelectedEstado] = useState('')
  const [selectedPuntuacion, setSelectedPuntuacion] = useState('')
  const [marcas, setMarcas] = useState([])

  useEffect(() => {
    fetchMarcas()
    fetchComentarios()
  }, [])

  const fetchMarcas = async () => {
    const { data } = await supabase
      .from('tiendas')
      .select('id, nombre')
      .order('nombre')
    setMarcas(data || [])
  }

  const fetchComentarios = async () => {
    try {
      setLoading(true)
      const { data, error } = await supabase
        .from('comentarios')
        .select(`
          *,
          tiendas(id, nombre),
          usuarios_marketing(nombre)
        `)
        .order('created_at', { ascending: false })

      if (error) throw error
      setComentarios(data || [])
    } catch (error) {
      console.error('Error:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleAprobar = async (comentarioId) => {
    try {
      const { error } = await supabase
        .from('comentarios')
        .update({
          publicado: true,
          fecha_gestion: new Date().toISOString()
        })
        .eq('id', comentarioId)

      if (error) throw error

      alert('Comentario aprobado exitosamente')
      fetchComentarios()
    } catch (error) {
      console.error('Error:', error)
      alert('Error al aprobar el comentario')
    }
  }

  const handleRechazar = async (comentarioId) => {
    if (!confirm('¿Estás seguro de rechazar este comentario? Se marcará como no publicado.')) return

    try {
      const { error } = await supabase
        .from('comentarios')
        .update({
          publicado: false,
          fecha_gestion: new Date().toISOString()
        })
        .eq('id', comentarioId)

      if (error) throw error

      alert('Comentario rechazado')
      fetchComentarios()
    } catch (error) {
      console.error('Error:', error)
      alert('Error al rechazar el comentario')
    }
  }

  const handleEliminar = async (comentarioId) => {
    if (!confirm('¿Estás seguro de eliminar este comentario permanentemente?')) return

    try {
      const { error } = await supabase
        .from('comentarios')
        .delete()
        .eq('id', comentarioId)

      if (error) throw error

      alert('Comentario eliminado exitosamente')
      fetchComentarios()
    } catch (error) {
      console.error('Error:', error)
      alert('Error al eliminar el comentario')
    }
  }

  // Filtros
  const filteredComentarios = comentarios.filter(comentario => {
    const matchesSearch = comentario.usuario_nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         comentario.usuario_email.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         comentario.comentario.toLowerCase().includes(searchTerm.toLowerCase())
    const matchesMarca = !selectedMarca || comentario.tienda_id === selectedMarca
    const matchesEstado = !selectedEstado || 
                         (selectedEstado === 'publicado' ? comentario.publicado : !comentario.publicado)
    const matchesPuntuacion = !selectedPuntuacion || 
                              comentario.puntuacion === parseInt(selectedPuntuacion)
    return matchesSearch && matchesMarca && matchesEstado && matchesPuntuacion
  })

  const comentariosPendientes = comentarios.filter(c => !c.publicado).length
  const comentariosPublicados = comentarios.filter(c => c.publicado).length
  const promedioGeneral = comentarios.length > 0
    ? (comentarios.reduce((sum, c) => sum + c.puntuacion, 0) / comentarios.length).toFixed(1)
    : '0.0'

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '3rem'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: '48px',
            height: '48px',
            border: '3px solid var(--background)',
            borderTop: '3px solid var(--accentPurple)',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 1rem'
          }}></div>
          <p style={{
            fontSize: 'var(--body)',
            fontFamily: 'var(--font-ui)',
            color: 'var(--textMuted)'
          }}>Cargando comentarios...</p>
        </div>
      </div>
    )
  }

  return (
    <div>
      {/* Header */}
      <div style={{ marginBottom: '1.5rem' }}>
        <h1 style={{
          fontSize: 'var(--h1)',
          fontWeight: '700',
          fontFamily: 'var(--font-display)',
          color: 'var(--textPrimary)'
        }}>COMENTARIOS</h1>
        <p style={{
          fontSize: 'var(--body)',
          fontFamily: 'var(--font-ui)',
          color: 'var(--textMuted)',
          marginTop: '0.25rem'
        }}>
          Modera y gestiona los comentarios de los clientes sobre las marcas
        </p>
      </div>

      {/* Info Alert */}
      <div style={{
        background: 'linear-gradient(135deg, #DBEAFE 0%, #EFF6FF 100%)',
        border: '1px solid #93C5FD',
        borderRadius: 'var(--radius-md)',
        padding: '1rem',
        marginBottom: '1.5rem'
      }}>
        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
          <span style={{ fontSize: '1.5rem', marginRight: '0.75rem' }}>ℹ️</span>
          <div>
            <p style={{
              fontWeight: '500',
              fontFamily: 'var(--font-ui)',
              color: '#1E3A8A'
            }}>IMPORTANTE</p>
            <p style={{
              fontSize: 'var(--small)',
              fontFamily: 'var(--font-ui)',
              color: '#1E40AF',
              marginTop: '0.25rem'
            }}>
              Solo puedes aprobar, rechazar o eliminar comentarios. No puedes crear comentarios falsos.
              Todos los comentarios provienen de usuarios reales del sitio web.
            </p>
          </div>
        </div>
      </div>

      {/* Stats */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '1rem',
        marginBottom: '1.5rem'
      }}>
        <div style={{
          background: 'var(--surface)',
          padding: '1.5rem',
          borderRadius: 'var(--radius-lg)',
          boxShadow: 'none',
          border: 'var(--card-border)',
        }}>
          <p style={{
            fontSize: 'var(--small)',
            fontFamily: 'var(--font-ui)',
            color: 'var(--textMuted)'
          }}>Total Comentarios</p>
          <p style={{
            fontSize: '1.875rem',
            fontWeight: '700',
            fontFamily: 'var(--font-display)',
            color: 'var(--accentPurple)'
          }}>{comentarios.length}</p>
        </div>
        <div style={{
          background: 'var(--surface)',
          padding: '1.5rem',
          borderRadius: 'var(--radius-lg)',
          boxShadow: 'none',
          border: 'var(--card-border)',
        }}>
          <p style={{
            fontSize: 'var(--small)',
            fontFamily: 'var(--font-ui)',
            color: 'var(--textMuted)'
          }}>Pendientes</p>
          <p style={{
            fontSize: '1.875rem',
            fontWeight: '700',
            fontFamily: 'var(--font-display)',
            color: '#EA580C'
          }}>{comentariosPendientes}</p>
        </div>
        <div style={{
          background: 'var(--surface)',
          padding: '1.5rem',
          borderRadius: 'var(--radius-lg)',
          boxShadow: 'none',
          border: 'var(--card-border)',
        }}>
          <p style={{
            fontSize: 'var(--small)',
            fontFamily: 'var(--font-ui)',
            color: 'var(--textMuted)'
          }}>Publicados</p>
          <p style={{
            fontSize: '1.875rem',
            fontWeight: '700',
            fontFamily: 'var(--font-display)',
            color: '#16A34A'
          }}>{comentariosPublicados}</p>
        </div>
        <div style={{
          background: 'var(--surface)',
          padding: '1.5rem',
          borderRadius: 'var(--radius-lg)',
          boxShadow: 'none',
          border: 'var(--card-border)',
        }}>
          <p style={{
            fontSize: 'var(--small)',
            fontFamily: 'var(--font-ui)',
            color: 'var(--textMuted)'
          }}>Promedio General</p>
          <p style={{
            fontSize: '1.875rem',
            fontWeight: '700',
            fontFamily: 'var(--font-display)',
            color: '#CA8A04'
          }}>⭐ {promedioGeneral}</p>
        </div>
      </div>

      {/* Filtros */}
      <div style={{
        background: 'var(--surface)',
        borderRadius: 'var(--radius-lg)',
        boxShadow: 'none',
        border: 'var(--card-border)',
        padding: '1.5rem',
        marginBottom: '1.5rem'
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '1rem'
        }}>
          {/* Buscar */}
          <input
            type="text"
            placeholder="Buscar por nombre, email o comentario..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              padding: '0.75rem 1rem',
              border: '1px solid var(--mutedStroke)',
              borderRadius: 'var(--radius-md)',
              fontSize: 'var(--body)',
              fontFamily: 'var(--font-ui)',
              color: 'var(--textPrimary)',
              transition: 'border-color 0.2s ease, box-shadow 0.2s ease'
            }}
            onFocus={(e) => {
              e.currentTarget.style.outline = 'none'
              e.currentTarget.style.borderColor = 'var(--accentPurple)'
              e.currentTarget.style.boxShadow = 'none'
            }}
            onBlur={(e) => {
              e.currentTarget.style.borderColor = 'var(--mutedStroke)'
              e.currentTarget.style.boxShadow = 'none'
            }}
          />

          {/* Filtro por marca */}
          <select
            value={selectedMarca}
            onChange={(e) => setSelectedMarca(e.target.value)}
            style={{
              padding: '0.75rem 1rem',
              border: '1px solid var(--mutedStroke)',
              borderRadius: 'var(--radius-md)',
              fontSize: 'var(--body)',
              fontFamily: 'var(--font-ui)',
              color: 'var(--textPrimary)',
              cursor: 'pointer',
              transition: 'border-color 0.2s ease, box-shadow 0.2s ease'
            }}
            onFocus={(e) => {
              e.currentTarget.style.outline = 'none'
              e.currentTarget.style.borderColor = 'var(--accentPurple)'
              e.currentTarget.style.boxShadow = 'none'
            }}
            onBlur={(e) => {
              e.currentTarget.style.borderColor = 'var(--mutedStroke)'
              e.currentTarget.style.boxShadow = 'none'
            }}
          >
            <option value="">Todas las marcas</option>
            {marcas.map(marca => (
              <option key={marca.id} value={marca.id}>{marca.nombre}</option>
            ))}
          </select>

          {/* Filtro por estado */}
          <select
            value={selectedEstado}
            onChange={(e) => setSelectedEstado(e.target.value)}
            style={{
              padding: '0.75rem 1rem',
              border: '1px solid var(--mutedStroke)',
              borderRadius: 'var(--radius-md)',
              fontSize: 'var(--body)',
              fontFamily: 'var(--font-ui)',
              color: 'var(--textPrimary)',
              cursor: 'pointer',
              transition: 'border-color 0.2s ease, box-shadow 0.2s ease'
            }}
            onFocus={(e) => {
              e.currentTarget.style.outline = 'none'
              e.currentTarget.style.borderColor = 'var(--accentPurple)'
              e.currentTarget.style.boxShadow = 'none'
            }}
            onBlur={(e) => {
              e.currentTarget.style.borderColor = 'var(--mutedStroke)'
              e.currentTarget.style.boxShadow = 'none'
            }}
          >
            <option value="">Todos los estados</option>
            <option value="publicado">✅ Publicados</option>
            <option value="pendiente">⏳ Pendientes</option>
          </select>

          {/* Filtro por puntuación */}
          <select
            value={selectedPuntuacion}
            onChange={(e) => setSelectedPuntuacion(e.target.value)}
            style={{
              padding: '0.75rem 1rem',
              border: '1px solid var(--mutedStroke)',
              borderRadius: 'var(--radius-md)',
              fontSize: 'var(--body)',
              fontFamily: 'var(--font-ui)',
              color: 'var(--textPrimary)',
              cursor: 'pointer',
              transition: 'border-color 0.2s ease, box-shadow 0.2s ease'
            }}
            onFocus={(e) => {
              e.currentTarget.style.outline = 'none'
              e.currentTarget.style.borderColor = 'var(--accentPurple)'
              e.currentTarget.style.boxShadow = 'none'
            }}
            onBlur={(e) => {
              e.currentTarget.style.borderColor = 'var(--mutedStroke)'
              e.currentTarget.style.boxShadow = 'none'
            }}
          >
            <option value="">Todas las puntuaciones</option>
            <option value="5">⭐⭐⭐⭐⭐ (5 estrellas)</option>
            <option value="4">⭐⭐⭐⭐ (4 estrellas)</option>
            <option value="3">⭐⭐⭐ (3 estrellas)</option>
            <option value="2">⭐⭐ (2 estrellas)</option>
            <option value="1">⭐ (1 estrella)</option>
          </select>
        </div>

        <div style={{
          marginTop: '0.75rem',
          fontSize: 'var(--small)',
          fontFamily: 'var(--font-ui)',
          color: 'var(--textMuted)'
        }}>
          Mostrando {filteredComentarios.length} de {comentarios.length} comentarios
        </div>
      </div>

      {/* Lista de Comentarios */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {filteredComentarios.length === 0 ? (
          <div style={{
            background: 'var(--surfaceMuted)',
            borderRadius: 'var(--radius-lg)',
            padding: '3rem',
            textAlign: 'center'
          }}>
            <p style={{
              fontSize: 'var(--body)',
              fontFamily: 'var(--font-ui)',
              color: 'var(--textMuted)'
            }}>No se encontraron comentarios</p>
          </div>
        ) : (
          filteredComentarios.map((comentario) => (
            <div 
              key={comentario.id} 
              style={{
                background: 'var(--surface)',
                borderRadius: 'var(--radius-lg)',
                boxShadow: 'none',
                border: 'var(--card-border)',
                borderLeft: `4px solid ${comentario.publicado ? '#16A34A' : '#EA580C'}`
              }}
            >
              <div style={{ padding: '1.5rem' }}>
                {/* Header */}
                <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '1rem' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '2.5rem',
                        height: '2.5rem',
                        background: 'var(--accentPurple)',
                        borderRadius: '50%',
                        color: 'var(--surface)',
                        fontWeight: '700'
                      }}>
                        {comentario.usuario_nombre.charAt(0).toUpperCase()}
                      </div>
                      <div>
                        <p style={{
                          fontWeight: '700',
                          fontFamily: 'var(--font-ui)',
                          color: 'var(--textPrimary)'
                        }}>{comentario.usuario_nombre}</p>
                        <p style={{
                          fontSize: 'var(--small)',
                          fontFamily: 'var(--font-ui)',
                          color: 'var(--textMuted)'
                        }}>{comentario.usuario_email}</p>
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginTop: '0.5rem' }}>
                      <span style={{
                        color: '#CA8A04',
                        fontSize: '1.25rem'
                      }}>
                        {'⭐'.repeat(comentario.puntuacion)}
                      </span>
                      <span style={{
                        fontSize: 'var(--small)',
                        fontFamily: 'var(--font-ui)',
                        color: 'var(--textMuted)'
                      }}>
                        sobre <strong style={{
                          color: 'var(--accentPurple)'
                        }}>{comentario.tiendas?.nombre || 'Marca eliminada'}</strong>
                      </span>
                    </div>
                  </div>

                  {/* Estado Badge */}
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '0.5rem' }}>
                    <span style={{
                      padding: '0.5rem 1rem',
                      borderRadius: 'var(--radius-full)',
                      fontSize: 'var(--small)',
                      fontWeight: '500',
                      color: `${comentario.publicado ? '#16A34A' : '#EA580C'}`,
                      background: `${comentario.publicado ? '#16A34A' : '#EA580C'}33`
                    }}>
                      {comentario.publicado ? '✅ Publicado' : '⏳ Pendiente'}
                    </span>
                    <span style={{
                      fontSize: 'var(--small)',
                      fontFamily: 'var(--font-ui)',
                      color: 'var(--textMuted)'
                    }}>
                      {new Date(comentario.created_at).toLocaleDateString('es-PE', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </span>
                  </div>
                </div>

                {/* Comentario */}
                <div style={{
                  background: 'var(--surfaceMuted)',
                  borderRadius: 'var(--radius-lg)',
                  padding: '1rem',
                  marginBottom: '1rem'
                }}>
                  <p style={{
                    fontSize: 'var(--body)',
                    fontFamily: 'var(--font-ui)',
                    color: 'var(--textPrimary)'
                  }}>{comentario.comentario}</p>
                </div>

                {/* Gestión Info */}
                {comentario.fecha_gestion && (
                  <div style={{
                    fontSize: 'var(--small)',
                    fontFamily: 'var(--font-ui)',
                    color: 'var(--textMuted)',
                    marginBottom: '1rem'
                  }}>
                    <span>Gestionado el {new Date(comentario.fecha_gestion).toLocaleDateString('es-PE', {
                      year: 'numeric',
                      month: 'short',
                      day: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })}</span>
                  </div>
                )}

                {/* Botones de Acción */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  {!comentario.publicado ? (
                    <>
                      <button
                        onClick={() => handleAprobar(comentario.id)}
                        style={{
                          padding: '0.5rem 1rem',
                          background: '#16A34A',
                          color: 'var(--surface)',
                          borderRadius: 'var(--radius-md)',
                          cursor: 'pointer',
                          transition: 'background 0.2s ease',
                          fontSize: 'var(--small)',
                          fontWeight: '500'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.background = '#14532D'}
                        onMouseLeave={(e) => e.currentTarget.style.background = '#16A34A'}
                      >
                        ✅ Aprobar y Publicar
                      </button>
                      <button
                        onClick={() => handleEliminar(comentario.id)}
                        style={{
                          padding: '0.5rem 1rem',
                          background: '#EF4444',
                          color: 'var(--surface)',
                          borderRadius: 'var(--radius-md)',
                          cursor: 'pointer',
                          transition: 'background 0.2s ease',
                          fontSize: 'var(--small)',
                          fontWeight: '500'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.background = '#DC2626'}
                        onMouseLeave={(e) => e.currentTarget.style.background = '#EF4444'}
                      >
                        🗑️ Eliminar
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        onClick={() => handleRechazar(comentario.id)}
                        style={{
                          padding: '0.5rem 1rem',
                          background: '#EA580C',
                          color: 'var(--surface)',
                          borderRadius: 'var(--radius-md)',
                          cursor: 'pointer',
                          transition: 'background 0.2s ease',
                          fontSize: 'var(--small)',
                          fontWeight: '500'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.background = '#CA8A04'}
                        onMouseLeave={(e) => e.currentTarget.style.background = '#EA580C'}
                      >
                        ⏸️ Despublicar
                      </button>
                      <button
                        onClick={() => handleEliminar(comentario.id)}
                        style={{
                          padding: '0.5rem 1rem',
                          background: '#EF4444',
                          color: 'var(--surface)',
                          borderRadius: 'var(--radius-md)',
                          cursor: 'pointer',
                          transition: 'background 0.2s ease',
                          fontSize: 'var(--small)',
                          fontWeight: '500'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.background = '#DC2626'}
                        onMouseLeave={(e) => e.currentTarget.style.background = '#EF4444'}
                      >
                        🗑️ Eliminar
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  )
}




